import { render, staticRenderFns } from "./waterInfo.vue?vue&type=template&id=0a664be6&"
import script from "./waterInfo.vue?vue&type=script&lang=js&"
export * from "./waterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports